import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Icon, Textfield, Fab } from '../../../components/BillingMDC';

import history from '../../../utils/history';
import Download from '../../common/Download';
import Loading from '../../../common/Loading';
import Pagination from '../../../components/Pagination';
import DrawerWithFilter from '../../common/DrawerFilter';
import TableHeader from '../../../components/TableHeader';
import * as queryService from '../../common/query.service';
import DateToRender from '../../../components/DateToRender';
import * as tableLayoutService from '../../common/tableLayout';
import { grnHeader, GRNTableBody } from './config';
import { GRN_CONFIG } from '../../common/domain.config';
import { GRN_CREATE, GRN_DETAILS } from '../../../data/enums/Route';
import PageHeaderStyled from '../../common/pagination/PageHeaderStyled';
import CreateBtn from '../../common/pagination/CreateBtn/CreateBtn';
import {storeInLocalStorage ,fetchFromLocalStorage} from "../../common/common";
import GRNStyled from './GRNStyled';

class GRN extends Component {
  constructor(props) {
    super(props);
    this.state = {
      display: {
        filter: false,
        menu: false,
        searchBox: false,
      },
      queryParameters: {
        ...queryService.queryParameters,
        filter: {
          business_id: [],
        },
      },
      data: {
        list: [],
        total: 1,
      },
    };

    const { downloadList } = this.props;

    this.paginationQueryService = new queryService.QueryClass(
      this.setQueryParameters,
      this.getQueryParameters,
      this.getTableDataForGrid,
      downloadList,
    );
    this.paginationQueryService.resetFilter();
  }

  /** adjust table width and height according to screen * */
  componentDidMount() {
    this.getFilterStateFromStorage();
    tableLayoutService.adjustToScreen(this.refs.tableReference, this.refs.fixedTableFooter, this.refs.fixedTableBody);
  }
  setFilterStateInStorage = () => {
    const { queryParameters,display} = this.state;
    storeInLocalStorage(
      'DISPLAY',
      display,
      'GRN'
    );
    storeInLocalStorage(
      'FILTER',
      {
       queryParameters,
      },
      "GRN"
    );
  };
  getFilterStateFromStorage = () => {
    const {queryParameters,display} =this.state;
    const localData = fetchFromLocalStorage('FILTER', "GRN");
    const localDisplay = fetchFromLocalStorage('DISPLAY', 'GRN');
    this.setState(
      { queryParameters:localData?.queryParameters || queryParameters ,
        display:{...localDisplay,filter:false} || display},
      () => {
        this.getTableDataForGrid();
      },
    );
  };
  handleClearSearch =() =>{
    const {display}=this.state;
    this.setState({display:{...display,searchBox:false,search:false}});
    this.paginationQueryService.clearSearchText();
  }

  setQueryParameters = (queryParameters, callBack = () => null) => this.setState({ queryParameters }, callBack);

  getQueryParameters = () => {
    const { queryParameters } = this.state;

    return queryParameters;
  };

  /** get data for grid, adjust loading flag */
  getTableDataForGrid = () => {
    const { getList } = this.props;
    const { queryParameters } = this.state;
    this.setFilterStateInStorage();
    getList(queryParameters).then(response => {
      const { data } = this.state;
      data.list = response.list;
      data.total = response.total;
      this.setState({ data });
    });
  };

  handleResetFilter =()=>{
    this.paginationQueryService.defaultResetFilter({
      ...queryService.queryParameters,
      filter: {
        business_id: [],
      },
    });
  }
  

  onPageSelect = (page, limit) => this.paginationQueryService.onPageSelect(page, limit);

  handleDateRangeChange = (start, end) => this.paginationQueryService.handleDateRangeChange(start, end);

  handleDateChange = date => this.paginationQueryService.handleDateRangeChange(date);

  handleFilterChange = (field, list) => this.paginationQueryService.handleFilterChange(field, list);

  handleTableSorting = (label, order) => this.paginationQueryService.handleTableSorting(label, order);

  handleSearchChange = value => this.paginationQueryService.handleSearchInputChange(value);

  handleDownloadClick = (reportType = 'csv') => this.paginationQueryService.handleDownloadClick(reportType);

  handleFabButtonClick = () => history.push(`${GRN_CREATE}`);

  onItemClick = data => {
    const grnID = data.idPurchase;
    history.push(`/${GRN_DETAILS}/${grnID}`);
  };


  controlDisplay = (label, value) => {
    const { display } = this.state;
    display[label] = value;
    this.setState(display);
  };

  render() {
    const { queryParameters, data, display } = this.state;

    const { serverResponseWaiting } = this.props;
    const filteredList  =Object.values(queryParameters.filter).flat().length;
    return (
      <GRNStyled>
        <Loading display={serverResponseWaiting} />
        <div className={`grn${serverResponseWaiting ? 'clickable-false' : ''}`}>
          <PageHeaderStyled>
            <div className="card-header-bar" ref="tableReference">
              <h2>GRN</h2>
              <div className="header-menu">
                <div className="header-menu-left ">
                  <span
                    className="search-icon-wrapper"
                    onClick={() => this.controlDisplay('searchBox', !display.searchBox)}
                  >
                    <Icon name="search" className="search-icon material-icons" />
                  </span>
                  <span className={`top-search-input-wrapper ${display.searchBox ? 'input-active' : 'input-inactive'}`}>
                    {display.searchBox && (
                      <Textfield
                        value={queryParameters.search}
                        onChange={e => {
                          this.handleSearchChange(e.target.value);
                        }}
                        autoFocus
                      />
                    )}
                    {queryParameters.search && (
                      <Icon name="close" className="cross-icon material-icons" onClick={() => this.handleClearSearch()} />
                    )}
                  </span>
                </div>
                <div className="header-menu-right">
                  <span className="date-rendered">
                    <Icon name="date_range" className="material-icons" />
                    <DateToRender date={queryParameters.date} />
                  </span>

                  <Download config={GRN_CONFIG} onClick={this.handleDownloadClick} />

                  <span onClick={() => this.controlDisplay('filter', true)} className="drawer_filter">
                    <Icon name="filter_list" />
                    {filteredList >0 &&  <span>{filteredList}</span>}
                  </span>
                </div>
              </div>
            </div>
          </PageHeaderStyled>

          <div ref="fixedTableBody" className="fixed-table-wrapper end-list-table">
            <table>
              <TableHeader headerDetails={grnHeader.headerDetails} handleSorting={this.handleTableSorting} />

              <GRNTableBody dataList={data.list} onRowClick={this.onItemClick} />
            </table>
          </div>
          <CreateBtn createHandler={this.handleFabButtonClick} />
          <div ref="fixedTableFooter">
            <Pagination
              pageSize={queryParameters.pagination.limit}
              currentPage={queryParameters.pagination.page}
              orientation="top"
              totalItems={data.total}
              onPageSelect={this.onPageSelect}
            />
          </div>
        </div>

        <DrawerWithFilter
          display={display.filter}
          displayController={this.controlDisplay}
          resetFilter={this.handleResetFilter}
          queryParameters={queryParameters}
          onDateRangeChange={this.handleDateRangeChange}
          handleFilterChange={this.handleFilterChange}
        />
      </GRNStyled>
    );
  }
}

const mapStateToProps = state => ({
  user: state.billing.user || null,
  company: state.billing.company || null,
  bu_id: state.billing.bu_id || null,
});

const GRNWithState = connect(mapStateToProps)(GRN);

export default GRNWithState;
